import { Ref, watch } from 'vue'

/**
 * Save a setting whenever the user changes it. If saving fails, put the setting back to the last saved
 * value (without saving again), so the control never shows something the server doesn't have.
 */
export function watchSavedSetting<T>(setting: Ref<T>, save: (value: T) => Promise<boolean>, lastSavedValue: () => T): void {
  let reverting = false
  watch(setting, async (value) => {
    if (reverting) {
      reverting = false
      return
    }
    if (await save(value)) {
      return
    }
    const savedValue = lastSavedValue()
    if (setting.value !== savedValue) {
      reverting = true
      setting.value = savedValue
    }
  })
}
